module.exports = __webpack_public_path__ + "img/V-45-ER-1000-GA.8403c8d9.png";